import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import debouncedResize from 'debounced-resize';

const phaseModule = document.querySelectorAll('.phase-module');

if (phaseModule) {
	gsap.registerPlugin(ScrollTrigger);

	let isMobile = window.innerWidth < 768;

	phaseModule.forEach(module => {
		const phases = module.querySelectorAll('.phase-module__phase');
		// Mobile animation (preserved from original)
		if (isMobile) {
			phases.forEach(phase => {
				const iconNumber = phase.querySelector('.phase-module__icon-number');
				const iconFigure = phase.querySelector('.phase-module__icon-figure');
				// Create animation for mobile (same as original)
				const tl = gsap.timeline();
				tl.to(iconNumber, {
					opacity: 0,
					yPercent: -100,
					duration: 0.5,
				});
				tl.to(iconFigure, {
					opacity: 1,
					y: 0,
					duration: 0.5,
				}, '<');

				// Original mobile ScrollTrigger settings
				ScrollTrigger.create({
					trigger: phase,
					start: 'top center-=20%',
					end: 'bottom center',
					markers: false,
					toggleActions: 'play none none reverse',
					animation: tl,
				});
			});
		} else {
			// Desktop animation with alternating layout
			phases.forEach(phase => {
				const icon = phase.querySelector('.phase-module__icon');
				const iconNumber = phase.querySelector('.phase-module__icon-number');
				const iconFigure = phase.querySelector('.phase-module__icon-figure');

				// Create animation for desktop
				const tl = gsap.timeline();
				tl.to(iconNumber, {
					opacity: 0,
					yPercent: -100,
					duration: 0.5,
				});
				tl.to(iconFigure, {
					opacity: 1,
					y: 0,
					duration: 0.5,
				}, '<');

				// Desktop ScrollTrigger settings
				ScrollTrigger.create({
					trigger: icon,
					start: 'center center+=20%',
					end: 'bottom center',
					markers: false,
					toggleActions: 'play none none reverse',
					animation: tl,
				});
			});
		}
	});

	// Use debouncedresize to update ScrollTrigger and heights
	debouncedResize(() => {
		isMobile = window.innerWidth < 768;
		ScrollTrigger.refresh();
	});
}
